export default __webpack_public_path__ + "static/media/gradient-left-dark-next-ui.15fedbb0.svg";